<script setup lang="ts">
import { usePathwayEventOverlay, usePathwayEvents } from '@/composables/game/pathway-events'

const { anyActivePathwayEvent, pathwayEvents } = usePathwayEvents()
const { showFirstPathway } = usePathwayEventOverlay()

</script>

<template>
  <span>Claim any step in
    <span
      :class="anyActivePathwayEvent ? 'text-teal-primary' : 'pointer-events-none'"
      @click="showFirstPathway(pathwayEvents)"
    >Pathway Events</span> to unlock this achievement.
  </span>
</template>

<style scoped>

</style>